import { render, staticRenderFns } from "./SalaryUserList.vue?vue&type=template&id=0353820a&scoped=true"
import script from "./SalaryUserList.vue?vue&type=script&lang=js"
export * from "./SalaryUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353820a",
  null
  
)

export default component.exports